<template>
  <div class="category container1">
    <!-- 已选 -->
    <dl class="selected cate_item" v-if="selectList.length > 0 || $route.query.searchKey">
      <dt class="label">您已选择</dt>
      <dd class="content">
        <div class="td-list">
          <span v-for="(item, index) in selectList" :key="index" class="td_item" @click="cancelSelect(item)">
            <span class="key_name">{{item.key?item.key+'：':""}}</span>
            <span>{{ item.value }}</span>
            <i class="myi el-icon-close"></i>
          </span>
          <!-- 关键词 -->
          <span class="td_item keyw" v-if="$route.query.searchKey">
            <span>{{`"${$route.query.searchKey}"`}}</span>
          </span>
          <span class="clear td_item com_link" v-if="selectList.length > 0 || !$route.query.searchKey" @click="clearSelect">清空选择</span>
        </div>
      </dd>
    </dl>
    <!-- 分类 -->
    <dl class="classify cate_item" :class="{'show':cateMore}">
      <dt class="label">分类</dt>
      <dd class="content" ref="cateContentRef">
        <div class="td-list">
          <span class="td_item com_link" :class="{active:!query.categorySerNo}" @click="sureCategory(undefined)">全部</span>
          <span :ref="'cateItem'+index" class="td_item com_link" :class="{active:query.categorySerNo == item.serNo}" v-for="(item, index) in categoryList" :key="index" @click="sureCategory(item.serNo)">
            {{ item.name }}
          </span>
        </div>
        <div class="td-more" v-if="cateContentHeight>48">
          <span class="com_link" @click="cateMore = !cateMore">
            <span>{{cateMore?"收起":'更多'}}</span>
            <i :class="cateMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </div>
      </dd>
    </dl>
    <!-- 空间 -->
    <dl class="attr cate_item" v-if="spaceList.length>0 && !$route.query.spaceSerNo" :class="{'show':spaceMore}">
      <dt class="label">适用空间</dt>
      <dd class="content" ref="spaceContentRef">
        <div class="td-list">
          <span class="td_item com_link" :class="{active:!query.spaceSerNo}" @click="sureSpace(undefined)">全部</span>
          <span v-for="(item, index) in spaceList" :key="index" class="td_item com_link" :class="{active:query.spaceSerNo == item.serNo}" @click="sureSpace(item.serNo)">
            {{ item.name }}
          </span>
        </div>
        <div class="td-more" v-if="spaceContentHeight>48">
          <span class="com_link" @click="spaceMore = !spaceMore">
            <span>{{spaceMore?"收起":'更多'}}</span>
            <i :class="spaceMore? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
          </span>
        </div>
      </dd>
    </dl>
    <!-- 品牌 -->
    <dl class="brand cate_item" v-if="brandList.length>0 && !$route.query.brandSerNos && $store.getters.userTypeA" :class="{'show':brandMore,'border2':brandMulti}">
      <dt class="label">品牌</dt>
      <dd class="content" ref="brandContentRef">
        <div class="td-list">
          <ul>
            <li v-for="(v, i) in brandList" :key="i" class="td_item" @click="chooseItem(brandList,v,brandMulti,'brand')">
              <i class="myicon iconfont icon-icon" :class="{ active: v.checked }"></i>
              <span class="brand_name" :class="{ active: v.checked }">{{ v.name }}</span>
              <span class="brand_no_url" v-show="!v.logoFilePath">{{ v.name }}</span>
              <div class="img_box">
                <img v-lazy="v.logoFilePath" />
              </div>
            </li>
          </ul>
          <div class="mutl-btn" v-if="brandMulti">
            <el-button class="btn" type="info" @click="confirmMulti(brandList,'brand')">确定</el-button>
            <el-button class="btn" type="info" @click="cancelMulti(brandList,'brand')">取消</el-button>
          </div>
        </div>
        <div class="td-more" v-show="!brandMulti">
          <span class="com_link" @click="brandMore = !brandMore" v-if="brandContentHeight>70">
            <span>{{brandMore?"收起":'更多'}}</span>
            <i :class="brandMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </div>
        <div class="td-mult" v-show="!brandMulti">
          <div class="mult_btn" @click="openMulti(true,false)">
            <i class="el-icon-plus"></i>
            <span>多选</span>
          </div>
        </div>
      </dd>
    </dl>
    <!-- 风格 -->
    <dl class="attr cate_item" v-if="styleList.length>0 && !$route.query.styleSerNos" :class="{'show':styleMore,'border2':styleMulti}">
      <dt class="label">风格</dt>
      <dd class="content" ref="styleContentRef">
        <div class="td-list">
          <span v-for="(v, i) in styleList" :key="i" class="td_item com_link" :class="{ active: v.checked }" @click="chooseItem(styleList,v,styleMulti,'style')">
            {{ v.name }}
          </span>
          <div class="mutl-btn" v-if="styleMulti">
            <el-button class="btn" type="info" @click="confirmMulti(styleList,'style')">确定</el-button>
            <el-button class="btn" type="info" @click="cancelMulti(styleList,'style')">取消</el-button>
          </div>
        </div>
        <div class="td-more" v-show="!styleMulti">
          <span class="com_link" @click="styleMore = !styleMore" v-if="styleContentHeight>48">
            <span>{{styleMore?"收起":'更多'}}</span>
            <i :class="styleMore? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
          </span>
        </div>
        <div class="td-mult" v-show="!styleMulti">
          <div class="mult_btn" @click="openMulti(false,true)">
            <i class="el-icon-plus"></i>
            <span>多选</span>
          </div>
        </div>
      </dd>
    </dl>
    <!-- 属性 -->
    <dl class="attr cate_item" :class="{'show':item.attrMore,'border2':item.attrMulti}" v-for="(item, index) in showProplist" :key="index">
      <dt class="label">{{ item.name }}</dt>
      <dd class="content" :ref="'attrContentRef'+index">
        <div class="td-list">
          <span v-for="(v, i) in item.fieldList" :key="i" class="td_item com_link" :class="{ active: v.checked }" @click="chooseItem(item.fieldList,v,item.attrMulti,'attr')">
            {{ v.value }}
          </span>
          <div class="mutl-btn" v-if="item.attrMulti">
            <el-button class="btn" type="info" @click="confirmMulti(item.fieldList,'attr')">确定</el-button>
            <el-button class="btn" type="info" @click="cancelMulti(item.fieldList,'attr',item)">取消</el-button>
          </div>
        </div>
        <div class="td-more" v-show="!item.attrMulti">
          <span class="com_link" @click="item.attrMore = !item.attrMore" v-if="item.attrContentHeight>48">
            <span>{{item.attrMore?"收起":'更多'}}</span>
            <i :class="item.attrMore? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
          </span>
        </div>
        <div class="td-mult" v-show="!item.attrMulti">
          <div class="mult_btn" @click="openMulti(false,false,item)">
            <i class="el-icon-plus"></i>
            <span>多选</span>
          </div>
        </div>
      </dd>
    </dl>
    <!-- 表头 -->
    <div class="table_header com_between">
      <div class="table_type">
        <div class="header_left cur_pointer" :class="{active:query.sortType==0}" @click="changeOrder(0)">
          <span>综合<i class="el-icon-bottom"></i></span>
        </div>

        <div class="header_left cur_pointer" :class="{active:query.sortType==4}" @click="changeOrder(4)">
          <span>销量<i class="el-icon-bottom"></i></span>
        </div>

        <div class="header_left cur_pointer" :class="{active:query.sortType==1}" @click="changeOrder(1)">
          <span>新品<i class="el-icon-bottom"></i></span>
        </div>

        <div class="header_left">
          <span class="price_box">价格
            <i class="el-icon-caret-top top_fz cur_pointer" :class="{active:query.sortType==3}" @click="changeOrder(3)"></i>
            <i class="el-icon-caret-bottom bottom_fz cur_pointer" :class="{active:query.sortType==2}" @click="changeOrder(2)"></i>
          </span>
        </div>

        <div class="price_ipt">
          <span class="text">价格</span>
          <el-input-number v-model="query.minPrice" @keyup.native="onKeyUp" :controls="false" :min="0" :max="999999" :precision="0" placeholder="￥"></el-input-number>
          <i class="el-icon-minus reduce"></i>
          <el-input-number v-model="query.maxPrice" @keyup.native="onKeyUp" :controls="false" :min="0" :max="9999999" :precision="0" placeholder="￥"></el-input-number>
          <el-button type="info" class="price_btn" @click="surePrice">确定</el-button>
          <p class="clear_btn" @click="query.minPrice=undefined;query.maxPrice=undefined;">清空</p>
        </div>

        <el-checkbox-group class="check_list" v-model="query.whole" @change="wholeChange">
          <el-checkbox label="0">精品</el-checkbox>
          <el-checkbox label="1">拎包商品</el-checkbox>
        </el-checkbox-group>

      </div>
      <div class="table_page" v-if="total">
        <span>{{'共'+total+'件商品'}}</span>
        <span class="totalPage">{{pageInfo.pageNumber+'/'+Math.ceil(total/pageInfo.pageSize)}}</span>
        <el-button class="btn" :disabled='pageInfo.pageNumber==1' icon="el-icon-arrow-left" @click="prevPage"></el-button>
        <el-button class="btn" :disabled='pageInfo.pageNumber==Math.ceil(total/pageInfo.pageSize) || total==0' @click="nextPage">
          <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </div>
    <div v-loading="loading" :style="{minHeight:loading?'600px':''}">
      <!-- 商品列表 -->
      <div class="table_list">
        <div class="list_item" v-for="(item,index) in dataGoodsList" :key="index">
          <div class="img_box">
            <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
              <img v-lazy="item.mainPreviewImageFilePath" alt="图片加载失败" />
            </router-link>
          </div>
          <div class="sprice" style="padding:6px 10px 0px;">
            市场参考价：
            <span class="line_th">￥{{ item.salePrice | priceValue }}</span>
          </div>
          <div class="price">
            <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{item.clientSalePrice | priceValue}}</p>
            <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
            <!-- <i class="boutique">{{item.isCanUseForWhole===0?"精品":"拎包"}}</i> -->
          </div>

          <div class="itr">
            <span class="sty_css" v-show="item.styleName">{{item.styleName}}</span>
            <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
              <span class="com_link">{{item.brandName+" "+item.goodsName+" "+item.mixName}}</span>
            </router-link>
          </div>
          <div class="sale">
            <div class="sale_item" v-if="item.saleCount!=null">
              <img :src="require('@/assets/img/yishousale.png')" alt="">{{item.saleCount+" "}}已售
            </div>
            <div class="sale_item" v-if="item.viewCount!=null">
              <img :src="require('@/assets/img/renqisale.png')" alt="">{{item.viewCount+" "}}人气
            </div>
          </div>
          <div class="add_cart">
            <el-button class="add_item" @click="followGoods(item)">加入收藏</el-button>
            <el-button class="add_item" type="primary" @click="addShoppingCart(item)">加入购物车</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 没有商品 -->
    <div class="no_goods" v-if="!total">产品正在更新上架，敬请期待。</div>
    <el-pagination class="pagination" v-if="dataGoodsList.length" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
  </div>
</template>

<script>
import index from "./js/category";
export default {
  ...index,
};
</script>

<style lang="less" scoped>
.category {
  padding-top: 14px;
  padding-bottom: 78px;
  font-size: 12px;
  .cate_item {
    border-bottom: dotted 1px #e6e6e6;
    .label {
      width: 90px;
      line-height: 40px;
      padding-left: 20px;
      float: left;

      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      width: calc(100% - 110px);
      box-sizing: border-box;
      padding: 8px 13px 8px 26px;
      margin-left: 110px;
      color: #333333;
      display: flex;
      .td-list {
        width: 90%;
        box-sizing: border-box;
        padding-right: 60px;
        line-height: 12px;
        .mutl-btn {
          text-align: center;
          margin-top: 10px;
          .btn {
            background-color: #f5f5f5;
            padding: 3px 15px 4px;
            color: #333333;
            border-radius: 2px;
            font-size: 12px;
          }
        }
      }
      .td-more {
        width: 5%;
        text-align: left;
        padding-top: 4px;
      }
      .td-mult {
        width: 5%;
        text-align: right;
        .mult_btn {
          width: 100%;
          height: 22px;
          line-height: 22px;
          border: 1px solid #b6b6b6;
          text-align: center;
          cursor: pointer;
          &:hover {
            color: @themeColor;
            border-color: @themeColor;
          }
        }
      }
    }
  }
  .border2 {
    border: 2px solid #ededed;
  }
  .selected {
    .content {
      color: @themeColor;
      .td-list {
        width: 100%;
        .td_item {
          display: inline-block;
          margin-right: 4px;
          margin-bottom: 6px;
          color: @themeColor;
          height: 16px;
          line-height: 16px;
          padding: 2px 5px 2px 8px;
          border-style: dotted;
          border-width: 1px;
          cursor: pointer;
          &:hover {
            border-style: solid;
          }
          .key_name {
            color: #555;
          }
          .myi {
            color: rgba(255, 0, 0, 1);
            padding-left: 6px;
          }
        }
        .clear {
          border-color: #fff;
          color: #999;
        }
        .keyw {
          cursor: text;
          color: #666;
          font-weight: bold;
          border: 1px solid #fff;
        }
      }
    }
  }
  .classify {
    background-color: #f5f5f7;
    overflow: hidden;
    height: 40px;
    .td-list {
      position: relative;
      .td_item {
        display: inline-block;
        margin-right: 15px;
        margin-bottom: 8px;
        border: none;
        padding: 6px 12px;
        cursor: pointer;

        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .active {
        background-color: @themeColor;
        color: #ffffff !important;
      }
    }
  }
  .brand {
    overflow: hidden;
    height: 62px;
    .td-list {
      ul {
        border-left: solid 1px #d2d2d2;
        overflow: hidden; //清除浮动
        .td_item {
          width: 104px;
          height: 54px;
          box-sizing: border-box;
          background: #ffffff;
          overflow: hidden;
          float: left;
          border-bottom: solid 1px #d2d2d2;
          border-right: solid 1px #d2d2d2;
          cursor: pointer;
          position: relative;
          .brand_name {
            display: none;
            border: solid 2px @themeColor;
          }
          .brand_no_url {
            display: inline-block;
          }
          .brand_name,
          .brand_no_url {
            width: 100%;
            height: 100%;
            line-height: 54px;
            box-sizing: border-box;
            color: @themeColor;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .img_box {
            background: #fff;
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;
            img {
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
              padding: 5px 7px;
              box-sizing: border-box;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
          &:nth-child(-n + 8) {
            border-top: solid 1px #d2d2d2;
          }
          &:hover {
            .img_box {
              display: none;
            }
            .brand_name {
              display: block;
            }
          }
          .myicon {
            display: none;
            color: @themeColor;
            position: absolute;
            bottom: 0;
            right: 0;
          }
          .active {
            display: block;
          }
        }
      }
    }
  }
  .attr {
    overflow: hidden;
    height: 40px;
    .td-list {
      .td_item {
        display: inline-block;
        padding: 5px 10px;
        margin-right: 15px;
        margin-bottom: 8px;
        cursor: pointer;
        color: #333333;
        border: 1px solid #fff;
      }
      .active {
        border: 1px solid @themeColor;
      }
    }
  }
  .show {
    height: auto;
  }
  .table_header {
    width: 100%;
    height: 40px;
    background: #f5f5f5;
    padding: 0 20px 0 0;
    box-sizing: border-box;
    font-size: 12px;
    margin-top: 18px;
    margin-bottom: 26px;
    color: #666666;
    .table_type {
      display: flex;
      height: 40px;
      line-height: 40px;
      border-left: 1px solid #d9d9d9;
      box-sizing: border-box;
      .header_left {
        width: 80px;
        height: 100%;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-left: none;
        text-align: center;
        .price_box {
          display: block;
          width: 60px;
          height: 100%;
          margin: 0 auto;
          text-align: center;
          position: relative;
          text-indent: -8px;
          .top_fz {
            position: absolute;
            top: 6px;
            right: -4px;
            font-size: 16px;
            width: 20px;
            height: 12px;
            line-height: 18px;
            overflow: hidden;
            // background-color: red;
          }
          .bottom_fz {
            position: absolute;
            bottom: 6px;
            right: -4px;
            font-size: 16px;
            width: 20px;
            height: 12px;
            line-height: 6px;
            overflow: hidden;
            // background-color: blue;
          }
        }
        i {
          font-size: 14px;
          font-weight: bold;
          padding-left: 4px;
        }
      }
      .price_ipt {
        margin-left: 22px;
        padding: 0 10px;
        border: 1px solid #f5f5f5;
        position: relative;
        .text {
          margin-right: 8px;
        }
        /deep/ .el-input-number {
          width: 68px;
          .el-input__inner {
            padding: 0 3px;
            height: 24px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            line-height: 24px;
            text-align: left;
          }
        }
        .reduce {
          margin: 0 4px;
        }
        .price_btn {
          display: none;
          position: absolute;
          bottom: 6px;
          right: 10px;
          background-color: #f5f5f5;
          padding: 3px 15px 4px;
          color: #333333;
          border-radius: 2px;
          font-size: 12px;
        }
        .clear_btn {
          display: none;
          position: absolute;
          bottom: 10px;
          left: 10px;
          line-height: 1;
          color: #005aa0;
          cursor: pointer;
        }
        &:hover {
          height: 66px;
          border: 1px solid #d9d9d9;
          background-color: #ffffff;
          .price_btn,
          .clear_btn {
            display: block;
          }
        }
      }
      .check_list {
        margin-left: 50px;
        /deep/ .el-checkbox__label {
          font-size: 12px;
        }
      }
      .active {
        color: @themeColor;
      }
    }
    .table_page {
      .totalPage {
        padding: 0 30px;
      }
      .btn {
        width: 46px;
        height: 24px;
        padding: 0px;
        line-height: 22px;
        border-radius: 0px;
      }
    }
  }
  .table_list {
    overflow: hidden; //清除浮动
    .list_item {
      background-color: #ffffff;
      width: calc((100% - 72px) / 4);
      float: left;
      border: 2px solid #f4f4f4;
      padding-top: 10px;
      box-sizing: border-box;
      margin-right: 24px;
      margin-bottom: 30px;
      font-size: 12px;
      transition: box-shadow 0.5s;
      -moz-transition: box-shadow 0.5s; /* Firefox 4 */
      -webkit-transition: box-shadow 0.5s; /* Safari and Chrome */
      -o-transition: box-shadow 0.5s; /* Opera */
      position: relative;
      &:hover {
        box-shadow: 0px 6px 5px 0px rgba(4, 0, 0, 0.21);
        margin-bottom: -14px;
        z-index: 2;
        .add_cart {
          display: block;
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      .img_box {
        width: 100%;
        height: 256px;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .price {
        font-size: 18px;
        font-weight: bold;
        color: #e52319;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .boutique {
          display: block;
          width: 32px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          background: #d8a67d;
          color: #fff;
          font-size: 12px;
          margin-left: 8px;
        }
      }
      .itr {
        padding: 0 10px;
        box-sizing: border-box;
        line-height: 20px;
        height: 40px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        .sty_css {
          display: inline-block;
          line-height: 1;
          background: #631717;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          font-weight: 500;
          min-width: 60px;
          box-sizing: border-box;
          display: inline-block;
          text-align: center;
          padding: 2px 6px;
          margin-right: 12px;
        }
        a {
          color: #000000;
        }
      }
      .sale {
        display: flex;
        justify-content: space-between;
        border-top: 2px solid #f4f4f4;
        margin-top: 4px;
        line-height: 30px;
        font-size: 12px;
        font-weight: 500;
        color: #631616;
        position: relative;
        .sale_item {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 12px;
            height: 14px;
            padding-right: 6px;
          }
        }
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          content: "";
          width: 1px;
          height: 16px;
          background: #f4f4f4;
          transform: translate(-50%, -50%);
        }
      }
      .add_cart {
        width: 100%;
        height: 44px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 8px 10px 10px;
        font-size: 14px;
        display: none;
        transition: box-shadow 0.5s;
        -moz-transition: box-shadow 0.5s; /* Firefox 4 */
        -webkit-transition: box-shadow 0.5s; /* Safari and Chrome */
        -o-transition: box-shadow 0.5s; /* Opera */
        .add_item {
          width: 50%;
          height: 26px;
          padding: 0;
          border-radius: 0;
          float: left;
          &:first-child {
            margin-left: 0;
            border: 1px solid #f4f4f4;
            color: @themeColor;
          }
          &:last-child {
            margin-left: 0;
          }
        }
      }
    }
  }
  .no_goods {
    height: 200px;
    line-height: 200px;
    font-size: 14px;
    font-weight: 700;
    background-color: #fffdee;
    border: 1px solid #edd28b;
    text-align: center;
  }
  .pagination {
    text-align: right;
    margin-top: 30px;
  }
  /deep/ .el-loading-spinner {
    top: 200px;
  }
}
</style>